import { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  CardMedia,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from "@mui/material";
import { UseAddOrder } from "./UseAddOrder";
import { UseOrders } from "../OrdersPage/UseOrders";
import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import MapOrder from "./MapOrder";
import useBreakpoints from "../../hooks/useBreakpoints";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";

export default function LocDetail(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { GetUserInfo, GetExpressDeliveryCost } = UseAddOrder();
  const [delivery, setDelivery] = useState();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);

  return (
    <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={() => {
          props.setOpenAddress({ ...props.openAddress, show: false });
        }}
        open={props.openAddress.show}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="subtitle1">انتخاب آدرس</Typography>
            <Button
              onClick={() => {
                props.setMyLocations({
                  ...props.myLocations,
                  provinceID: 1,
                  cityID: 1,
                  neighbourhoodID: 0,
                });
              }}
              variant="outlined"
            >
              تهران
            </Button>
          </Box>
        </DialogTitle>

        {props.openAddress.show && (
          <Box
            sx={{
              mx: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {props.openAddress.addresses?.length ? (
              <Autocomplete
                size="small"
                onChange={(event, newValue) => {
                  let neighbourhood = props.locations
                    ?.find((m) => m.id == newValue?.provinceID)
                    ?.cities.find((m) => m.id == newValue?.cityID)
                    ?.neighbourhoods.find(
                      (m) => m.id == newValue?.neighbourhoodID,
                    );
                  if (newValue) {
                    props.setMyLocations({
                      ...props.myLocations,
                      provinceID: newValue.provinceID
                        ? newValue.provinceID
                        : undefined,
                      cityID: newValue.cityID ? newValue.cityID : undefined,
                      neighbourhoodID: newValue.neighbourhoodID
                        ? newValue.neighbourhoodID
                        : 0,
                      province: newValue.province,
                      city: newValue.city,
                      neighbourhood: newValue.neighbourhood,
                      address: newValue.address,
                      postCode: newValue.postCode,
                      neighbourhoodMotor: neighbourhood?.motorcycleDelivery,
                      neighbourhoodExpress: neighbourhood?.expressDelivery,
                      latitude: newValue.latitude,
                      longitude: newValue.longitude,
                    });
                    props.setState({
                      ...props.state,
                      latitude: newValue.latitude,
                      longitude: newValue.longitude,
                    });
                  } else if (
                    newValue &&
                    (neighbourhood?.motorcycleDelivery == false ||
                      neighbourhood?.expressDelivery == false)
                  ) {
                    props.setDeliveryType([]);
                    props.setDeliveryTimes([]);
                    props.setSendType({ title: "" });
                    props.setValueAuto({ name: "" });
                    props.setDelivery();
                    props.setState({
                      ...props.state,
                      deliveryType: "",
                      deliveryID: "",
                    });
                  } else if (newValue == null) {
                    props.setMyLocations({
                      ...props.myLocations,
                      // address: "",
                      neighbourhoodMotor: false,
                      neighbourhoodExpress: false,
                    });
                    props.setDeliveryType([]);
                    props.setDeliveryTimes([]);
                    props.setSendType({ title: "" });
                    props.setValueAuto({ name: "" });
                    props.setDelivery();
                    props.setState({
                      ...props.state,
                      deliveryType: "",
                      deliveryID: "",
                    });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return option.address;
                  }
                  return "";
                }}
                renderOption={(props, option, { selected }) => {
                  return (
                    <li {...props}>
                      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                        <Typography variant="body2">
                          {option.address}
                        </Typography>
                      </Box>
                    </li>
                  );
                }}
                filterSelectedOptions
                fullWidth
                options={
                  props.openAddress.addresses &&
                  props.openAddress.addresses.length > 0
                    ? props.openAddress.addresses
                    : []
                }
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="آدرس ها" />
                )}
              />
            ) : (
              ""
            )}
            <Box
              sx={{
                p: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: isSmall ? "column" : "row",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                  width: isSmall ? "100%" : "50%",
                }}
              >
                <Autocomplete
                  fullWidth
                  size="small"
                  value={
                    props.myLocations.provinceID
                      ? props.myLocations.provinceID
                      : ""
                  }
                  onChange={(event, newValue) => {
                    props.setMyLocations({
                      ...props.myLocations,
                      provinceID: newValue,
                      cityID: undefined,
                      neighbourhoodID: 0,
                    });
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return value == "" || option === value;
                  }}
                  getOptionLabel={(option) => {
                    if (option) {
                      return (
                        props.locations !== undefined &&
                        props.locations.find((m) => m.id == option)?.title
                      );
                    }
                    return "";
                  }}
                  options={
                    props.locations && props.locations.length > 0
                      ? props.locations.map((m) => m.id)
                      : []
                  }
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="استان" />
                  )}
                />
                <Autocomplete
                  fullWidth
                  size="small"
                  value={
                    props.myLocations.cityID ? props.myLocations.cityID : ""
                  }
                  onChange={(event, newValue) => {
                    props.setMyLocations({
                      ...props.myLocations,
                      provinceID: props.myLocations.provinceID,
                      cityID: newValue,
                      neighbourhoodID: 0,
                    });
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return value == "" || option === value;
                  }}
                  getOptionLabel={(option) => {
                    if (option) {
                      return (
                        props.locations &&
                        props.locations
                          .find((m) => m.id == props.myLocations.provinceID)
                          ?.cities.find((m) => m.id == option)?.title
                      );
                    }
                    return "";
                  }}
                  options={
                    props.locations?.length > 0 && props.myLocations.provinceID
                      ? props.locations
                          .find((m) => m.id == props.myLocations.provinceID)
                          ?.cities.map((m) => m.id)
                      : []
                  }
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="شهر" />
                  )}
                />
                <Autocomplete
                  fullWidth
                  size="small"
                  value={
                    props.myLocations.neighbourhoodID
                      ? props.myLocations.neighbourhoodID
                      : ""
                  }
                  onChange={(event, newValue) => {
                    let neighbourhood = props.locations
                      ?.find((m) => m.id == props.myLocations.provinceID)
                      ?.cities.find((m) => m.id == props.myLocations.cityID)
                      ?.neighbourhoods.find((m) => m.id == newValue);
                    if (newValue) {
                      props.setMyLocations({
                        ...props.myLocations,
                        neighbourhoodID: newValue,
                        neighbourhoodMotor: neighbourhood?.motorcycleDelivery,
                        neighbourhoodExpress: neighbourhood?.expressDelivery,
                      });
                    } else if (
                      newValue &&
                      (neighbourhood?.motorcycleDelivery == false ||
                        neighbourhood?.expressDelivery == false)
                    ) {
                      props.setDeliveryType([]);
                      props.setDeliveryTimes([]);
                      props.setSendType({ title: "" });
                      props.setValueAuto({ name: "" });
                      props.setDelivery();
                      props.setState({
                        ...props.state,
                        deliveryType: "",
                        deliveryID: "",
                      });
                    } else if (!newValue || newValue == null) {
                      props.setMyLocations({
                        ...props.myLocations,
                        neighbourhoodID: 0,
                        neighbourhoodMotor: false,
                        neighbourhoodExpress: false,
                      });
                      props.setDeliveryType([]);
                      props.setDeliveryTimes([]);
                      props.setSendType({ title: "" });
                      props.setValueAuto({ name: "" });
                      props.setDelivery();
                      props.setState({
                        ...props.state,
                        deliveryType: "",
                        deliveryID: "",
                      });
                    }
                  }}
                  isOptionEqualToValue={(option, value) => {
                    return value == "" || option === value;
                  }}
                  getOptionLabel={(option) => {
                    if (option) {
                      return props.locations !== undefined &&
                        props.locations
                          .find((m) => m.id == props.myLocations.provinceID)
                          ?.cities.find((m) => m.id == props.myLocations.cityID)
                          ?.neighbourhoods?.length > 0
                        ? props.locations
                            .find((m) => m.id == props.myLocations.provinceID)
                            .cities.find(
                              (m) => m.id == props.myLocations.cityID,
                            )
                            .neighbourhoods.find((m) => m.id == option)?.title
                        : "";
                    }
                    return "";
                  }}
                  options={
                    props.locations?.length > 0 && props.myLocations.cityID
                      ? props.locations
                          ?.find((m) => m.id == props.myLocations.provinceID)
                          ?.cities.find((m) => m.id == props.myLocations.cityID)
                          ?.neighbourhoods.map((m) => m.id)
                      : []
                  }
                  renderInput={(params) => (
                    <TextField variant="outlined" {...params} label="محله" />
                  )}
                />{" "}
                <Button
                  color="secondary"
                  sx={{ my: 3 }}
                  variant="contained"
                  onClick={() => {
                    if (
                      !window.ENV.neighborhoodNotValidation &&
                      props.myLocations.cityID == 1 &&
                      props.myLocations.neighbourhoodID == 0
                    ) {
                      enqueueSnackbar("لطفا محله را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    if (
                      delivery?.title == "ارسال سریع با پیک موتوری" &&
                      (!props.myLocations.longitude ||
                        !props.myLocations.latitude)
                    ) {
                      props.setOpenAddress({
                        ...props.openAddress,
                        show: true,
                      });
                      enqueueSnackbar(
                        "برای ارسال سریع با پیک موتوری لطفا آدرس را روی نقشه انتخاب کنید",
                        {
                          variant: "error",
                          autoHideDuration: 2000,
                          preventDuplicate: true,
                        },
                      );
                      return;
                    } else if (delivery?.title == "ارسال سریع با پیک موتوری") {
                      GetExpressDeliveryCost(
                        props.orderID,
                        props.myLocations,
                        (callback) => {
                          props.setValueAuto({
                            name:
                              delivery.description +
                              " (" +
                              callback.costTitle +
                              ")",
                          });
                          enqueueSnackbar("هزینه ارسال محاسبه شد", {
                            variant: "success",
                            autoHideDuration: 2000,
                            preventDuplicate: true,
                          });
                          props.setRow({
                            ...props.row,
                            deliveryCost: callback.cost,
                          });
                          props.setState({
                            ...props.state,
                            deliveryID: callback.deliveryID,
                            cityID: props.myLocations.cityID,
                            provinceID: props.myLocations.provinceID,
                            province: props.myLocations.province,
                            city: props.myLocations.city,
                            neighbourhoodID: props.myLocations.neighbourhoodID,
                            neighbourhood: props.myLocations.neighbourhood,
                            address: props.myLocations.address,
                            postCode: props.myLocations.postCode,
                            longitude: props.myLocations.longitude,
                            latitude: props.myLocations.latitude,
                          });
                        },
                      );
                    }

                    props.setState({
                      ...props.state,
                      cityID: props.myLocations.cityID,
                      provinceID: props.myLocations.provinceID,
                      province: props.myLocations.province,
                      city: props.myLocations.city,
                      neighbourhoodID: props.myLocations.neighbourhoodID,
                      neighbourhood: props.myLocations.neighbourhood,
                      address: props.myLocations.address,
                      postCode: props.myLocations.postCode,
                      longitude: props.myLocations.longitude,
                      latitude: props.myLocations.latitude,
                    });
                    props.setOpenAddress({ ...props.openAddress, show: false });
                  }}
                >
                  ثبت
                </Button>
              </Box>
              <Box
                sx={{
                  width: isSmall ? "100%" : "50%",
                  display: "flex",
                  justifyContent: "flex-end",
                  ml: !isSmall && 3,
                }}
              >
                <MapContainer
                  center={[
                    props.myLocations.latitude
                      ? props.myLocations.latitude
                      : 35.7009,
                    props.myLocations.longitude
                      ? props.myLocations.longitude
                      : 51.391241,
                  ]}
                  // center={center}
                  zoom={15}
                  style={{
                    height: "350px",
                    width: "500px",
                  }}
                >
                  <MapOrder
                    myLocations={props.myLocations}
                    setMyLocations={props.setMyLocations}
                  />
                </MapContainer>
              </Box>
            </Box>
          </Box>
        )}
      </Dialog>
      <Box
        sx={{
          display: "flex",
          alignItems: isSmall ? "flex-start" : "center",
          flexDirection: isSmall ? "column" : "row",
          justifyContent: "space-between",
          width: "100%",
          gap: isSmall && 2,
        }}
        gridColumn="span 12"
      >
        <TextField
          fullWidth
          id="outlined-basic"
          error={props.errorState.provinceID}
          label={`استان ${
            props.state.provinceID &&
            props.locations &&
            props.locations.find((m) => m.id == props.state.provinceID)
              ? " : " +
                props.locations.find((m) => m.id == props.state.provinceID)
                  .title
              : " : نامشخص"
          } `}
          size="small"
          sx={{
            width: isSmall ? "100%" : "30%",
            "& .MuiInputLabel-root": {
              color: "#646464",
            },
            input: {
              py: 1.2,
            },
          }}
          InputLabelProps={{
            shrink: false,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
        <TextField
          fullWidth
          error={props.errorState.cityID}
          id="outlined-basic"
          label={`شهر ${
            props.state.cityID &&
            props.locations &&
            props.locations
              .find((m) => m.id == props.state.provinceID)
              ?.cities.find((m) => m.id == props.state.cityID)
              ? " : " +
                props.locations
                  .find((m) => m.id == props.state.provinceID)
                  .cities.find((m) => m.id == props.state.cityID)?.title
              : " : نامشخص"
          } `}
          size="small"
          sx={{
            width: isSmall ? "100%" : "30%",
            ml: !isSmall && 1,
            "& .MuiInputLabel-root": {
              color: "#646464",
            },
            input: {
              py: 1.2,
            },
          }}
          InputLabelProps={{
            shrink: false,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
        <TextField
          fullWidth
          id="outlined-basic"
          label={`محله ${
            props.state.neighbourhoodID &&
            props.locations &&
            props.locations
              .find((m) => m.id == props.state.provinceID)
              ?.cities.find((m) => m.id == props.state.cityID)
              ?.neighbourhoods.find((m) => m.id == props.state.neighbourhoodID)
              ? " : " +
                props.locations
                  .find((m) => m.id == props.state.provinceID)
                  .cities.find((m) => m.id == props.state.cityID)
                  .neighbourhoods.find(
                    (m) => m.id == props.state.neighbourhoodID,
                  )?.title
              : " : نامشخص"
          } `}
          size="small"
          sx={{
            ml: !isSmall && 1,
            width: isSmall ? "100%" : "30%",
            "& .MuiInputLabel-root": {
              color: "#646464",
            },
            input: {
              py: 1.2,
            },
          }}
          InputLabelProps={{
            shrink: false,
          }}
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
        />
        <Button
          sx={{ ml: 1, width: "5%" }}
          onClick={() =>
            props.setOpenAddress({ ...props.openAddress, show: true })
          }
          color="secondary"
          variant="contained"
        >
          ویرایش
        </Button>
      </Box>
    </Box>
  );
}
